export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4597.98256930.jpg";